import React from 'react';
import Like from 'icons/like';
import ResourceCircle from 'icons/resourceCircle/resourceCircle';
import style from './overlay.module.scss';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectIsLikePending, selectPendingLikeId } from 'store/page/pageSlice';
import { likeRequest } from 'store/page/pageSlice';
import ContextActionsComponent, {
  ContextAction,
  ContextActionHandler,
} from 'controls/contextActions/contextActions';
import { Resource, PossibleAction } from 'store/types';
import { useEditHandler } from 'hooks/contentActionHandlers/useEditHandler';
import map from 'lodash-es/map';
import { useDownloadHandler } from 'hooks/contentActionHandlers/useDownloadHandler';
import { useDeleteHandler } from 'hooks/contentActionHandlers/useDeleteHandler';
import cx from 'classnames';

export default function Overlay(props: {
  id: string;
  item: Resource;
  disableLikes?: boolean;
  actions?: PossibleAction[];
}) {
  const dispatch = useAppDispatch();
  const isLikePending = useAppSelector(selectIsLikePending);
  const pendingLikeId = useAppSelector(selectPendingLikeId);
  const isThisPending = isLikePending && pendingLikeId === props.id;

  const handlers: { [x in PossibleAction]?: ContextActionHandler } = {
    edit: useEditHandler({
      contextItem: props.item,
    }),
    delete: useDeleteHandler({
      contextItem: props.item,
    }),
    download: useDownloadHandler({
      contextItem: props.item,
    }),
  };

  return (
    <div className={style.container}>
      {!props.disableLikes && (
        <div className={cx(style.item, 'adaptive-overlay__item')}>
          <ResourceCircle
            className={'adaptive-overlay__resourceCircle'}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();

              !isLikePending &&
                dispatch(
                  likeRequest({
                    _id: props.id,
                    liked: !props.item.is_liked,
                  })
                );
            }}
          >
            <Like
              className={style.like}
              liked={isThisPending ? !props.item.is_liked : props.item.is_liked}
            />
          </ResourceCircle>
        </div>
      )}
      {props.actions && (
        <div className={cx(style.item, 'adaptive-overlay__item')}>
          <ContextActionsComponent
            resourceCircleClassName="adaptive-overlay__resourceCircle"
            iconClassName="adaptive-overlay__icon"
            bubbleClassName={style.bubble}
            actions={map(props.actions, (actionType) => {
              const contextAction: ContextAction = {
                type: actionType,
              };

              if (handlers[actionType] !== undefined) {
                contextAction.handler = handlers[actionType];
              }

              return contextAction;
            })}
          ></ContextActionsComponent>
        </div>
      )}
    </div>
  );
}
